const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatBRL(value: number): string {
  return brlFormatter.format(value);
}

import { maskMoneyInput, parseMoneyMask, numberToMoneyMask } from './moneyMask';

export { maskMoneyInput, parseMoneyMask, numberToMoneyMask };

export function parseBRLInput(value: string): number {
  return parseMoneyMask(value);
}

/** Converte string com vírgula ou ponto em número; arredonda para centavos. Ex: "10,5" => 10.50 */
export function parseDecimalBRL(value: string): number {
  if (value.trim() === '') return 0;
  const normalized = value.trim().replace(',', '.');
  const parsed = parseFloat(normalized);
  if (Number.isNaN(parsed)) return 0;
  return Math.round(parsed * 100) / 100;
}
